<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right10 flex-box nopadding">
                    <el-button size="small" @click="openSave()" :title="$t('upd')" icon="el-icon-edit-outline"></el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" v-print="printObj" :title="$t('print')" icon="el-icon-printer"></el-button>
                </el-button-group>
            </div>
            <div class="fillw fillh">
                <table class="info-box" id="print_area">
                    <tr>
                        <td class="org-cname bg-back" colspan="4">{{info.org_cname}}</td>
                    </tr>
                    <tr v-if="info.org_code != ''">
                        <td class="cell_name">{{ $t("code")}}</td>
                        <td colspan="2">{{info.org_code}}</td>
                        <td rowspan="7" class="img-lnk">
                            <img :src="info.img_lnk"/></td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("join_type_cname")}}</td>
                        <td colspan="1">{{info.join_type_cname}}</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("org_admin_code")}}</td>
                        <td colspan="1">{{info.org_admin_code}}</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("end_time")}}</td>
                        <td colspan="1">{{info.end_time}}({{info.day_qty}}{{$t('day')}})</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{$t("status")}}</td>
                        <td colspan="1">{{info.org_status_cdesc}}</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("p_org")}}</td>
                        <td colspan="3">{{info.org_pcname}} ({{$t("cu_cname")}}{{$t("x_mh")}}{{info.org_pcname_cu_cname}} {{info.org_pcname_cu_mobile || '未设置'}})</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{$t("addr2")}}</td>
                        <td colspan="3">
                            {{info.prov}}{{info.city}}{{info.area}}
                        </td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("addr")}}</td>
                        <td colspan="3">{{info.addr}}</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("link_cname")}}</td>
                        <td colspan="3">{{info.link_cname}}</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("link_mobile")}}</td>
                        <td colspan="3">{{info.link_mobile}}</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("cu_cname")}}</td>
                        <td colspan="3">{{info.cu_cname || '未设置'}}</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("cu_mobile")}}</td>
                        <td colspan="3">{{info.cu_mobile || '未设置'}}</td>
                    </tr>
                    <tr>
                        <td class="cell_name">{{ $t("cu_time_area")}}</td>
                        <td colspan="3">{{info.cu_time_area || '未设置'}}</td>
                    </tr>
                </table>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    export default {
        name:"org-info",
        components:{
        },
        data:function(){
            return{
                show_subview:false,
                relist:false,
                search:{
                    search_url:'org/info',
                },
                listTable: {},//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                info: {},
                printObj:{
                    id:'#print_area',
                    popTitle: '-',
                    endCallback(){}
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.info = data;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openSave:function () {
                this.$base.linkTo("/org/info/save",{});
            },
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped >
    .info-box{
        border: solid 1px #e5e5e5;
        min-width: 800px;
        background-color: #fff;
        border-collapse:collapse;
    }
    .info-box tr{
        border-top: solid 1px #e5e5e5;
    }
    .info-box td{
        padding: 10px;
    }
    .info-box .cell_name{
        background-color: #f8f8f8;
        width: 150px;
    }

    .info-box .org-cname{
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
    }
    .info-box .img-lnk{
        text-align: center;
        background-color: #f8f8f8;
    }
    .info-box .img-lnk img{
        width: 150px;
        max-height: 150px;
    }
    .img-style-div img{
        width: 80px;
        height: 80px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/info/info.vue